import { useLocation, Navigate, useSearchParams } from 'react-router-dom';
import useAppSelector from 'hooks/useAppSelector';
import {
  AUTH_URL,
  PUBLIC_ROUTES,
  ROUTES,
  VALID_ACTIONS
} from 'utils/constants';
import { redirectToCandidate, redirectToCompany } from 'utils/redirect';
import { isUpdatedTerms, requiredDataCompleted } from 'utils/user';

interface GuardRouteProps {
  children: JSX.Element;
}

function GuardRoute({ children }: GuardRouteProps) {
  const location = useLocation();
  const { pathname } = location;
  const [searchParams] = useSearchParams();
  const action = searchParams.get('action') ?? '';
  const reference = searchParams.get('reference') ?? '';
  const redirectPath = window.atob(reference);

  const { isAuthenticated, user, userType, hasCnpj, requiredCompanyCompleted } =
    useAppSelector((state) => state.auth);

  const requiredUserCompleted = requiredDataCompleted(user);

  if (!isAuthenticated) {
    if (!VALID_ACTIONS.includes(action) && !AUTH_URL.includes('localhost')) {
      // window.location.replace(WORDPRESS_URL);
    }

    if (!PUBLIC_ROUTES.includes(pathname)) {
      return <Navigate to={`${ROUTES.AUTHENTICATION}${location.search}`} />;
    }
  } else {
    if (!requiredUserCompleted && pathname !== ROUTES.REQUIREMENTS) {
      return <Navigate to={`${ROUTES.REQUIREMENTS}${location.search}`} />;
    }

    if (
      requiredUserCompleted &&
      !isUpdatedTerms(user?.policyVersion) &&
      pathname !== ROUTES.TERMS
    ) {
      return <Navigate to={`${ROUTES.TERMS}${location.search}`} />;
    }

    if (requiredUserCompleted && isUpdatedTerms(user?.policyVersion)) {
      if (userType === 'candidate') {
        redirectToCandidate(redirectPath);
      } else {
        if (!hasCnpj && pathname !== ROUTES.CREATE_COMPANY) {
          return <Navigate to={`${ROUTES.CREATE_COMPANY}${location.search}`} />;
        }

        if (hasCnpj && !requiredCompanyCompleted) {
          return <Navigate to={`${ROUTES.FORM_COMPANY}${location.search}`} />;
        }

        if (hasCnpj && requiredCompanyCompleted) {
          redirectToCompany(redirectPath);
        }
      }
    }
  }

  return children;
}

export default GuardRoute;
